function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React from 'react';
import { HtmlRenderer, Parser } from 'commonmark';
import '../css/markdown.css';
import { getRandomId } from './util';
var htmlwriter = new HtmlRenderer({
  sourcepos: false,
  softbreak: "<br />"
});
var reader = new Parser(); // monkey patch HtmlRender to make links open in a new tab

htmlwriter.link = function (node, entering) {
  var attrs = [];

  if (entering) {
    attrs.push(['href', this.esc(node.destination, true)]);
    attrs.push(['target', '_blank']);

    if (node.title) {
      attrs.push(['title', this.esc(node.title, true)]);
    }

    this.tag('a', attrs);
  } else {
    this.tag('/a');
  }
};

var Markdown =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Markdown, _React$Component);

  function Markdown() {
    _classCallCheck(this, Markdown);

    return _possibleConstructorReturn(this, _getPrototypeOf(Markdown).apply(this, arguments));
  }

  _createClass(Markdown, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          linkColor = _this$props.linkColor,
          text = _this$props.text,
          underlineLinks = _this$props.underlineLinks;
      var id = getRandomId();
      return React.createElement("div", {
        id: id,
        className: "cmp-markdown"
      }, React.createElement("style", null, "\n        #".concat(id, " a {\n          color: ").concat(linkColor, ";\n          ").concat(underlineLinks ? 'text-decoration: underline;' : '', "\n        }\n      ")), React.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: htmlwriter.render(reader.parse(text))
        }
      }));
    }
  }]);

  return Markdown;
}(React.Component);

export default Markdown;